import axios from 'axios';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
// api
import ApiKey from '../api/ApiKey';
import BaseApi from '../api/BaseApi';
// components
import Sidebar from './Sidebar';
import NavBar from '../element/NavBar';
import Footer from '../element/Footer';
// helpers
import { logOutIfTokenExpired, resultInfo } from '../helpers';

const MailDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation('global');
  const userType = Cookies.get('user_type');
  const tokenKey = Cookies.get('tokenClient');

  const [empty, setEmpty] = useState(false);
  const [loading, setLoading] = useState(true);
  const [mailDetail, setMailDetail] = useState(null);
  const [mailSender, setMailSender] = useState(null);
  const [mailReceiver, setMailReceiver] = useState(null);
  const [mailReply, setMailReply] = useState({ subject: '', message: '' });
  const [validationMessages, setValidationMessages] = useState({ subject: '', message: '' });

  const getData = async () => {
    try {
      setLoading(true);

      const response = await axios.post(
        BaseApi + `/users/maildetail/${slug}`,
        null,
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
            contentType: 'application/json',
          },
        },
      );

      setLoading(false);

      if (response.data.status === 200) {
        setMailDetail(response.data.response.mails);
        setMailReply(prev => ({ ...prev, subject: response.data.response.mails.subject || '' }));

        if (response.data.response.mails.reciever !== null) {
          setMailReceiver(response.data.response.mails.reciever);
        }

        if (response.data.response.mails.sender !== null) {
          setMailSender(response.data.response.mails.sender);
        }
      } else if (response.data.status === 400) {
        navigate('/');
        Cookies.remove('fname');
        Cookies.remove('user_id');
        Cookies.remove('user_type');
        Cookies.remove('tokenClient');

        resultInfo('warning', response.data.message, t('membershipPlan.close'));
      } else {
        Swal.fire({
          icon: 'error',
          text: response.data.message,
          confirmButtonText: t('membershipPlan.close'),
          title: t('employerFavouriteListProfile.addFavFailedTitle'),
        });
      }
    } catch (error) {
      setLoading(false);

      if (error.message === 'Network Error' || error.response.data.message === 'Token has expired') {
        navigate('/');

        logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
      }

      console.error('Cannot get mail detail of mail history page at employer side', error);
    }
  };

  const handleChange = e => {
    const { name, value } = e.target;

    setMailReply(prev => ({
      ...prev,
      [name]: value,
    }));

    setValidationMessages(prev => ({
      ...prev,
      [name]: '',
    }));

    if (!validationMessages.subject == '' || !validationMessages.message == '') {
      setEmpty(true);
    }

    if (mailReply.subject == '' || mailReply.message == '') {
      setEmpty(true);
    }
  };

  const handleReply = async slug => {
    try {
      if (!mailReply.subject.trim() || !mailReply.message.trim()) {
        setValidationMessages(prevMessages => ({
          ...prevMessages,
          subject:
            mailReply.subject.trim() === ''
              ? t('jobseekerMailDetail.subjectRequired')
              : '',
          message:
            mailReply.message.trim() === ''
              ? t('jobseekerMailDetail.messageRequired')
              : '',
        }));

        setEmpty(false);

        return;
      }
      setEmpty(true);

      const updatedReply = {
        ...mailReply,
        id: mailDetail.from_id,
      };

      setLoading(true);

      const response = await axios.post(
        BaseApi + `/candidates/sendmailemployer/${slug}`,
        updatedReply,
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
            contentType: 'application/json',
          },
        },
      );

      setLoading(false);

      if (response.data.status === 200) {
        resultInfo('success', t('jobseekerMailDetail.replySentSuccess'), t('jobseekerMailDetail.close'));

        window.history.back();
      } else if (response.data.status === 400) {
        navigate('/');

        Cookies.remove('fname');
        Cookies.remove('user_id');
        Cookies.remove('user_type');
        Cookies.remove('tokenClient');

        resultInfo('warning', response.data.message, t('jobseekerMailDetail.close'));
      } else {
        resultInfo('error', response.data.message, t('jobseekerMailDetail.close'));
      }
    } catch (error) {
      setLoading(false);

      if (error.message === 'Network Error' || error.response.data.message === 'Token has expired') {
        navigate('/');

        logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
      } else {
        Swal.fire({
          icon: 'error',
          text: t('jobseekerMailDetail.failedTxt'),
          title: t('jobseekerMailDetail.failedTitle'),
          confirmButtonText: t('jobseekerMailDetail.close'),
        });
      }

      console.error(error);
    }
  };

  useEffect(() => {
    if (userType === 'candidate' || !tokenKey) {
      navigate('/auth/employer-login');
    } else {
      getData();

      window.scrollTo(0, 0);
    }
  }, [tokenKey, navigate, userType]); // eslint-disable-line

  return (
    <>
      <NavBar />
      <div className='container editProfile'>
        <div className='row'>
          <div className='col-lg-3'>
            <Sidebar />
          </div>
          {
            loading
              ? (
                <div className='loader-container' />
              ) : (
                <div className='col-lg-9 mb-5 mailDetail'>
                  <div className='mx-3 d-flex mb-4 PageHeader'>
                    <img src='/Images/employerSide/icon8color.png' alt='' />
                    <h3 className=''>{t('employerMailDetail.mailDetail')}</h3>
                  </div>
                  <div className='mx-4 mb-5 mailDetailBx'>
                    {
                      mailReceiver && (
                        <h5>
                          {t('employerMailDetail.dear')}{' '}
                          {mailReceiver?.first_name ? mailReceiver?.first_name : ''}
                          {' '}
                          {mailReceiver?.last_name ? mailReceiver?.last_name : ''}
                        </h5>
                      )
                    }
                    {
                      mailSender && (
                        <>
                          <p>
                            {
                              mailReceiver.employer_id === 0
                                ? (
                                  t('jobseekerMailDetail.line1')
                                )
                                : (
                                  <>
                                    {t('employerMailDetail.jobseeker')}{' '}
                                    <span className='fw-bold'>
                                      {mailSender?.first_name ? mailSender?.first_name : ''}
                                      {' '}
                                      {mailSender?.last_name ? mailSender?.last_name : ''}
                                    </span>
                                    {' '}
                                    {t('employerMailDetail.line1')}
                                  </>
                                )
                            }
                            <br />
                            {
                              mailReceiver.employer_id === 0
                                ? (
                                  <>
                                    <span className='fw-bold'>
                                      {t('jobseekerMailDetail.companyName')}:{' '}
                                    </span>
                                    {mailSender?.company_name ? mailSender?.company_name : ''}
                                    <br />
                                  </>
                                )
                                : ''
                            }
                            <span className='fw-bold'>
                              {t('employerMailDetail.subject')}:{' '}
                            </span>
                            {mailDetail?.subject ? mailDetail?.subject : ''}
                            <br />
                            <span className='fw-bold'>
                              {t('employerMailDetail.message')}:{' '}
                            </span>
                            {mailDetail?.message ? mailDetail?.message : ''}
                          </p>
                          {
                            mailReceiver.employer_id !== 0
                              ? (
                                <div className='MDButtonBx'>
                                  <button
                                    data-bs-toggle='modal'
                                    className='mt-4 btn button1'
                                    data-bs-target='#ReplyModal'
                                  >
                                    {t('jobseekerMailDetail.replyButton')}
                                  </button>
                                </div>
                              )
                              : ''
                          }
                        </>
                      )
                    }
                  </div>
                </div>
              )
          }
        </div>
        <div
          tabIndex='-1'
          id='ReplyModal'
          aria-hidden='true'
          className='modal fade'
          aria-labelledby='exampleModalLabel'
        >
          <div className='modal-dialog'>
            <div className='modal-content'>
              <div className='modal-header'>
                <h1 className='modal-title fs-5' id='exampleModalLabel'>
                  {t('jobseekerMailDetail.replyMail')}
                </h1>
                <button
                  type='button'
                  aria-label='Close'
                  className='btn-close'
                  data-bs-dismiss='modal'
                ></button>
              </div>
              <div className='modal-body'>
                <div className='form-outline mb-5 mt-4 DashBoardInputBx'>
                  <label className='form-label' htmlFor='subject'>
                    {t('jobseekerMailDetail.subject')}{' '}
                    <span className='RedStar'>*</span>
                  </label>
                  <input
                    type='text'
                    id='subject'
                    name='subject'
                    onChange={handleChange}
                    className='form-control'
                    value={mailReply.subject}
                    placeholder={t('jobseekerMailDetail.subject')}
                  />
                  <div className='text-danger mt-2'>
                    {validationMessages.subject}
                  </div>
                </div>
                <div className='form-outline mb-5 DashBoardInputBx'>
                  <label className='form-label' htmlFor='message'>
                    {t('jobseekerMailDetail.message')}
                    <span className='RedStar'>*</span>
                  </label>
                  <textarea
                    rows={6}
                    id='message'
                    name='message'
                    onChange={handleChange}
                    value={mailReply.message}
                    placeholder={t('employerFavouriteListProfile.message')}
                    className={`form-control FLPTextarea ${validationMessages.message && 'input-error'}`}
                  ></textarea>
                  <div className='text-danger mt-2'>
                    {validationMessages.message}
                  </div>
                </div>
                <button
                  type='button'
                  aria-label={empty && 'close'}
                  data-bs-dismiss={empty && 'modal'}
                  className='btn btn-primary button1'
                  onClick={() => handleReply(mailDetail.slug)}
                >
                  {t('jobseekerMailDetail.submitButton')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default MailDetail;
